import { render, staticRenderFns } from "./TheSidebar.vue?vue&type=template&id=5ebb8953&"
import script from "./TheSidebar.vue?vue&type=script&lang=ts&"
export * from "./TheSidebar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports